import { createSvgComponent } from "../../icon/createSvgComponent";
import StarFill from "@core/__generated__/icon/figma/star-fill.svg";
export default createSvgComponent(StarFill);